<script lang="ts">
  export let options: any;
  export let selectedOptionValue: string;
  export let onChange: any = () => {};
  export let optionField = "value";

  $: orderedOptions = options
    .filter(o => o[optionField] == selectedOptionValue)
    .slice(0, 1)
    .concat(options);

</script>

<div class="fizz-text-strong">
  <select
    class="fizz-select"
    name="product_sort"
    id="product-sort-select"
    on:change={onChange}
    bind:value={selectedOptionValue}
  >
    {#each orderedOptions as option, sortIndex}
      <option value={option[optionField]}>
        {sortIndex === 0 ? "Sort by: " : ""}{option.text}
      </option>
    {/each}
  </select>
</div>
